<template>
    <div class="account">
        <div class="top_header_fixed">
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item :to="{ path: '/hierarchyList' }">职位</el-breadcrumb-item>
                <el-breadcrumb-item>职位{{ type == 'update' ? '编辑' : '新增' }}</el-breadcrumb-item>
            </el-breadcrumb>
            <div class="title_btn">
                <div>
                    <el-button size="small" plain @click="submit('submitForm')" :loading="btnLoading">保存</el-button>
                    <el-button size="small" plain @click="cancel">取消</el-button>
                </div>
            </div>
        </div>
        <div class="main_list">
            <el-collapse v-model="activeNames">
                <el-collapse-item disabled title="基本信息" name="1">
                    <el-form :model="formData" :rules="rules" ref="submitForm" label-position="right" class="details_temp2023">
                        <template v-for="(item, index) in colData">
                            <template v-if="formData.hasOwnProperty(item.prop)">
                                <el-form-item
                                    v-if="fieldTypeMap.hasOwnProperty(item.prop) && fieldTypeMap[item.prop]['type'] == 'dropdown'"
                                    :key="index"
                                    :label="fieldTypeMap[item.prop]['title'] + '：'"
                                    :rules="rules[item['prop']] || {}"
                                    :prop="item['prop']"
                                >
                                    <vDropdown
                                        :model_key="item['prop']"
                                        :model_name="'请选择' + fieldTypeMap[item.prop]['title']"
                                        :model_value_default="data[item['prop']]"
                                        :request_uri="fieldTypeMap[item.prop]['request_uri']"
                                        @onDropChange="onDropChange"
                                        :display_name="fieldTypeMap[item.prop]['display_name']"
                                        :select_value="fieldTypeMap[item.prop]['select_value']"
                                        :ref="fieldTypeMap[item.prop]['ref']"
                                        :request_params="fieldTypeMap[item.prop]['request_params'] || {}"
                                        :is_disable="type == 'update' && item['prop'] == 'superior_rid'"
                                        :insert_router="fieldTypeMap[item.prop]['insert_router'] || ''"
                                    ></vDropdown>
                                    <el-tooltip
                                        v-if="fieldTypeMap.hasOwnProperty(item.prop) && fieldTypeMap[item.prop].hasOwnProperty('tips')"
                                        :class="{
                                            Tooltip3: fieldTypeMap[item.prop] && fieldTypeMap[item.prop]['insert_router'],
                                            Tooltip: !(fieldTypeMap[item.prop] && fieldTypeMap[item.prop]['insert_router'])
                                        }"
                                        effect="dark"
                                        :content="fieldTypeMap[item.prop]['tips']"
                                        placement="top-start"
                                    >
                                        <i class="el-icon-question"></i>
                                    </el-tooltip>
                                </el-form-item>
                                <el-form-item
                                    v-else
                                    :key="index"
                                    :label="item['title'] + '：'"
                                    :rules="rules[item['prop']] || {}"
                                    :prop="item['prop']"
                                >
                                    <el-input
                                        v-model="formData[item['prop']]"
                                        size="mini"
                                        :placeholder="'请输入' + item.title"
                                        :disabled="type == 'update' && item['prop'] == 'code'"
                                        clearable
                                    ></el-input>
                                    <el-tooltip
                                        v-if="fieldTypeMap.hasOwnProperty(item.prop) && fieldTypeMap[item.prop].hasOwnProperty('tips')"
                                        :class="{
                                            Tooltip3: fieldTypeMap[item.prop] && fieldTypeMap[item.prop]['insert_router'],
                                            Tooltip: !(fieldTypeMap[item.prop] && fieldTypeMap[item.prop]['insert_router'])
                                        }"
                                        effect="dark"
                                        :content="fieldTypeMap[item.prop]['tips']"
                                        placement="top-start"
                                    >
                                        <i class="el-icon-question"></i>
                                    </el-tooltip>
                                </el-form-item>
                            </template>
                            <template v-else>
                                <el-form-item v-if="type == 'update'" :key="index" :label="item['title'] + '：'">
                                    <div class="read_only">
                                        {{ data[item['prop']] }}
                                    </div>
                                </el-form-item>
                            </template>
                        </template>
                    </el-form>
                </el-collapse-item>
            </el-collapse>
        </div>
    </div>
</template>
<script>
import { in_array, processColDataToEdit } from '@/js/common.js';

export default {
    name: 'hierarchyEdit',
    data() {
        return {
            type: '', // insert or update or copy
            activeNames: ['1'],
            btnLoading: false,
            colData: [], // 字段信息
            formData: {}, // 表单信息
            data: {}, // 详情数据
            fieldTypeMap: {},
            queryParams: {}, // 搜索参数（详情）
            rules: {} // 表单验证信息
        };
    },
    created() {
        this.type = this.$route.query.type;
        this.initQueryParams();
        this.selectedColData(); //筛选列
        this.initFormRule();
        this.initFieldTypeMap();
        if (in_array(this.type, ['update', 'copy'])) {
            this.getData();
        } else {
            this.data.status = 1;
            this.data.department_rid = this.$route.query.department_rid || '';
            this.initFormData();
        }
    },
    methods: {
        onDropChange(key, value) {
            this.formData[key] = value;
        },
        initFieldTypeMap() {
            this.fieldTypeMap = {
                status: {
                    request_uri: 'dropdownOpenCloseStatus',
                    title: '状态',
                    ref: 'status_ref',
                    display_name: 'name',
                    select_value: 'value',
                    type: 'dropdown'
                },
                rank: {
                    request_uri: 'decisionRank',
                    title: '等级',
                    ref: 'rank_ref',
                    display_name: 'name',
                    select_value: 'value',
                    type: 'dropdown'
                },
                department_rid: {
                    request_uri: 'dropdownDepartment',
                    title: '部门',
                    ref: 'department_rid_ref',
                    display_name: 'name',
                    type: 'dropdown',
                    insert_router: 'departmentEdit',
                    tips: '上级一旦确认不允许修改，特殊场景请删除/禁用职位后重新新增'
                },
                superior_rid: {
                    request_uri: 'dropdownHierarchyLists',
                    title: '上级',
                    ref: 'superior_rid_ref',
                    display_name: 'name',
                    type: 'dropdown',
                    request_params: { team_role: 1 },
                    tips: '上级一旦确认不允许修改，特殊场景请删除/禁用职位后重新新增'
                },
                staffing: {
                    tips: '默认为1，填0表示虚拟职位'
                },
                team_role: {
                    request_uri: 'teamRole',
                    title: '团队角色',
                    ref: 'team_role_ref',
                    display_name: 'name',
                    select_value: 'value',
                    type: 'dropdown'
                },
                department_role: {
                    request_uri: 'yesOrNo',
                    title: '部门负责',
                    ref: 'department_role_ref',
                    display_name: 'name',
                    select_value: 'value',
                    type: 'dropdown'
                }
            };
        },
        initFormRule() {
            this.rules = {
                code: [{ required: true, message: '请输入代码', trigger: 'blur' }],
                staffing: [{ required: true, message: '请输入编制', trigger: 'blur' }],
                status: [{ required: true, message: '请选择状态', trigger: 'blur' }],
                name: [{ required: true, message: '请输入名称', trigger: 'blur' }],
                rank: [{ required: true, message: '请选择等级', trigger: 'blur' }],
                department_rid: [{ required: true, message: '请选择部门', trigger: 'blur' }],
                superior_rid: [{ required: true, message: '请选择上级', trigger: 'blur' }],
                team_role: [{ required: true, message: '请选择团队角色', trigger: 'blur' }],
                department_role: [{ required: true, message: '是否部门负责', trigger: 'blur' }]
            };
        },
        initQueryParams() {
            this.queryParams.rid = this.$route.query.id;
        },
        initFormData() {
            this.formData = {
                rid: this.data.rid || '',
                code: this.data.code || '',
                status: this.data.status ? this.data.status : 1,
                name: this.data.name || '',
                rank: this.data.rank ? this.data.rank : '',
                department_rid: this.data.department_rid || '',
                superior_rid: this.data.superior_rid || '',
                team_role: this.data.team_role || '',
                department_role: this.data.department_role || '',
                remark: this.data.remark || '',
                staffing: typeof this.data.staffing != 'undefined' ? this.data.staffing + '' : '1'
            };
        },
        //筛选列
        selectedColData() {
            let temp = JSON.parse(localStorage.getItem('detailList')).hierarchy;

            processColDataToEdit(
                temp,
                this,
                {
                    white: ['code', 'name', 'remark', 'team_role', 'remark', 'department_role', 'staffing']
                },
                {
                    status_label: 'status',
                    rank_label: 'rank',
                    team_role_label: 'team_role',
                    department_role_label: 'department_role',
                    department_name: 'department_rid',
                    superior_name: 'superior_rid'
                }
            );
        },
        //取消
        cancel() {
            if (window.history.length <= 1) {
                this.$router.push({ path: '/hierarchyList' });
            } else {
                this.$router.go(-1);
            }
        },
        //获取详情
        getData() {
            this.$api
                .hierarchyDetail(this.queryParams)
                .then((res) => {
                    this.data = res.data;
                    this.initFormData();
                })
                .catch((error) => {});
        },
        //提交新增/编辑修改
        submit(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.doSubmit();
                    return true;
                } else {
                    return false;
                }
            });
        },
        doSubmit() {
            this.btnLoading = true;
            let uri = '';
            if (this.type == 'update') {
                uri = 'hierarchyUpdate';
            } else {
                uri = 'hierarchyInsert';
            }
            this.$api[uri](this.formData)
                .then((res) => {
                    this.btnLoading = false;
                    this.$message({
                        message: '保存成功！',
                        type: 'success'
                    });
                    this.cancel();
                })
                .catch((error) => {
                    this.btnLoading = false;
                });
        }
    }
};
</script>
<style lang="scss" scoped="scoped">
</style>